import Card from '@/components/UI/Card';

const ReviewerChecklistCard = () => (
    <Card responsivePadding bodyClassName="space-y-4" title="Reviewer Checklist">
        <div className="text-sm leading-6 text-zinc-300">
            <div>1. Pick a preset or exact symbol/date that shows a real OBV event or state transition.</div>
            <div>2. Use focused-marker mode first, then widen to all filtered markers only if needed.</div>
            <div>3. Confirm the price chart context and the OBV line/signal panel make the focused label believable.</div>
            <div>4. Check the focused runtime state below for bias, signal relationship, structure, breakout, and divergence.</div>
            <div>5. If the focused day has a screener snapshot, confirm the daily materialized numbers are understandable and usable.</div>
            <div>6. Have a trader or domain owner answer whether they would trust these labels in a live strategy workflow.</div>
        </div>

        <div className="rounded-lg border border-zinc-800 bg-zinc-950/70 p-4 text-sm text-zinc-300">
            <div className="mb-2 text-[11px] uppercase tracking-[0.16em] text-zinc-500">What To Sign Off</div>
            <div>UI review: the page exposes the right labels and the correct chart context.</div>
            <div>
                Domain review: bullish/bearish bias, accumulation/distribution, breakout, and divergence semantics feel trader-legible.
            </div>
            <div>Screener review: the daily snapshot fields are interpretable enough to build and debug rules.</div>
        </div>

        <div className="rounded-lg border border-zinc-800 bg-zinc-950/70 p-4 text-sm text-zinc-300">
            <div className="mb-2 text-[11px] uppercase tracking-[0.16em] text-zinc-500">Best Current Review Set</div>
            <div>DAR `30m` bullish cross</div>
            <div>NKE `30m` bearish cross</div>
            <div>AAPL `1d` daily snapshot</div>
        </div>
    </Card>
);

export default ReviewerChecklistCard;
